import { render } from "./ServerView.vue?vue&type=template&id=584105de&scoped=true"
import script from "./ServerView.vue?vue&type=script&lang=js"
export * from "./ServerView.vue?vue&type=script&lang=js"

import "./ServerView.vue?vue&type=style&index=0&id=584105de&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584105de"]])

export default __exports__